var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { RadioButtons } from "@animech/ui";
import * as Styled from "./saved-systems.style";
import { applicationTypes } from "store/user/util";
/** The radio value representing "no filter" / all applications. */
var ALL_APPLICATIONS = "all";
export var ApplicationFilter = function (_a) {
    var selected = _a.selected, onChange = _a.onChange;
    var t = useTranslation().t;
    var items = __spreadArray([
        ALL_APPLICATIONS
    ], __read(applicationTypes), false);
    var itemLabels = __spreadArray([
        t("home-menu.saved-systems.applications.all")
    ], __read(applicationTypes.map(function (type) {
        return t("home-menu.saved-systems.applications.".concat(type));
    })), false);
    return (_jsxs(Styled.ApplicationFilter, { children: [_jsx(Styled.ApplicationFilterLabel, { children: t("home-menu.saved-systems.filter-by-application") }), _jsx(RadioButtons, { layout: "row", appearance: "ghost", color: "inverted", items: items, itemLabels: itemLabels, value: selected !== null && selected !== void 0 ? selected : ALL_APPLICATIONS, onValueChange: function (value) {
                    return onChange(value === ALL_APPLICATIONS ? undefined : value);
                } })] }));
};
